// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IzjF","left":"styles_left__bxQtW"};